function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import BigNumber from "bignumber.js";
import { repeat } from "lodash";
import { roundNumber } from ".";

function replaceInFormat(format, _ref) {
  var formattedNumber = _ref.formattedNumber,
      unit = _ref.unit;
  return format.replace("%n", formattedNumber).replace("%u", unit);
}

function computeSignificand(_ref2) {
  var significand = _ref2.significand,
      whole = _ref2.whole,
      precision = _ref2.precision;

  if (whole === "0" || precision === null) {
    return significand;
  }

  var limit = Math.max(0, precision - whole.length);
  return (significand !== null && significand !== void 0 ? significand : "").substr(0, limit);
}

export function formatNumber(input, options) {
  var _a, _b, _c;

  var originalNumber = new BigNumber(input);

  if (options.raise && !originalNumber.isFinite()) {
    throw new Error("\"".concat(input, "\" is not a valid numeric value"));
  }

  var roundedNumber = roundNumber(originalNumber, options);
  var numeric = new BigNumber(roundedNumber);
  var isNegative = numeric.lt(0);
  var isZero = numeric.isZero();

  var _roundedNumber$split = roundedNumber.split("."),
      _roundedNumber$split2 = _slicedToArray(_roundedNumber$split, 2),
      whole = _roundedNumber$split2[0],
      significand = _roundedNumber$split2[1];

  var buffer = [];
  var formattedNumber;
  var positiveFormat = (_a = options.format) !== null && _a !== void 0 ? _a : "%n";
  var negativeFormat = (_b = options.negativeFormat) !== null && _b !== void 0 ? _b : "-".concat(positiveFormat);
  var format = isNegative && !isZero ? negativeFormat : positiveFormat;
  whole = whole.replace("-", "");

  while (whole.length > 0) {
    buffer.unshift(whole.substr(Math.max(0, whole.length - 3), 3));
    whole = whole.substr(0, whole.length - 3);
  }

  whole = buffer.join("");
  formattedNumber = buffer.join(options.delimiter);

  if (options.significant) {
    significand = computeSignificand({
      whole: whole,
      significand: significand,
      precision: options.precision
    });
  } else {
    significand = significand !== null && significand !== void 0 ? significand : repeat("0", (_c = options.precision) !== null && _c !== void 0 ? _c : 0);
  }

  if (options.stripInsignificantZeros && significand) {
    significand = significand.replace(/0+$/, "");
  }

  if (originalNumber.isNaN()) {
    formattedNumber = input.toString();
  }

  if (significand && originalNumber.isFinite()) {
    formattedNumber += (options.separator || ".") + significand;
  }

  return replaceInFormat(format, {
    formattedNumber: formattedNumber,
    unit: options.unit
  });
}